module.exports = __webpack_public_path__ + "static/img/装饰6.2d822d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装饰6.svg
// module id = VVG6
// module chunks = 2